import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import BarChartIcon from '@mui/icons-material/BarChart';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DescriptionIcon from '@mui/icons-material/Description';
import colors from "../../theme/colors";
import { User } from "../../Models/User";

import Item from "../Shared/Style/StyledItem";

export default function Negocio() {
  const navigate = useNavigate();
  const rawUser = sessionStorage.getItem("User");
  const user = rawUser ? (JSON.parse(rawUser) as User) : null;
  const isAdm = user?.papel == 'Administrador'

  const NavigateTo = (path: string) => {
    navigate(path);
  }

  return (
    <Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2 }, minHeight: { xs: "auto", md: "90vh" }, display: 'flex', flexDirection: 'column' }}>
      <Paper sx={{ p: { xs: 1, sm: 2 }, height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* Linha 1 - Cabeçalho e Descrição */}
            <Grid item xs={12}>
              <Paper sx={{ p: 1, bgcolor: '#f8f9fa' }}>
                <h4 style={{ margin: '0 0 0 0', color: colors.bluePrimary, textAlign: 'left' }}>
                  🏢 Negócio
                </h4>
                <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
                  Gestão e análise dos aspectos principais do negócio
                </Typography>
              </Paper>
            </Grid>
        <Grid container spacing={2} sx={{ flexGrow: 1, marginTop:1 }}>
          {/* Linha 2 - Cards de Navegação */}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {/* Card - Gráfico de Vendas */}
              <Grid item xs={12} sm={6} md={4} sx={{display: isAdm ? 'flex' : 'none'}}>
                <Item onClick={() => NavigateTo("../graficos")}>
                  <Box sx={{
                    display: isAdm ? 'flex' : 'none',
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 1
                  }}>
                    <BarChartIcon
                      sx={{
                        color: colors.accent,
                        fontSize: '2.5em',
                        mb: 1
                      }}
                    />
                    <Typography variant="h6" sx={{ color: colors.bluePrimary, fontWeight: 'bold', mb: 1 }}>
                      Gráfico de Vendas
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                      Análise detalhada das vendas e performance
                    </Typography>
                  </Box>
                </Item>
              </Grid>

              {/* Card - Relatórios de Pedidos */}
              <Grid item xs={12} sm={6} md={4} sx={{display: isAdm ? 'flex' : 'none'}}>
                <Item onClick={() => NavigateTo("../relatorios-pedidos")}>
                  <Box sx={{
                    display: isAdm ? 'flex' : 'none',
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 1
                  }}>
                    <AssessmentIcon
                      sx={{
                        color: colors.accent,
                        fontSize: '2.5em',
                        mb: 1
                      }}
                    />
                    <Typography variant="h6" sx={{ color: colors.bluePrimary, fontWeight: 'bold', mb: 1 }}>
                      Estatísticas de Pedidos
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                      Relatórios detalhados por canal e período
                    </Typography>
                  </Box>
                </Item>
              </Grid>

              {/* Card - Relatório por Dia da Semana */}
              <Grid item xs={12} sm={6} md={4} sx={{display: isAdm ? 'flex' : 'none'}}>
                <Item onClick={() => NavigateTo("../relatorio-pedidos-dia-semana")}>
                  <Box sx={{
                    display: isAdm ? 'flex' : 'none',
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 1
                  }}>
                    <CalendarTodayIcon
                      sx={{
                        color: colors.accent,
                        fontSize: '2.5em',
                        mb: 1
                      }}
                    />
                    <Typography variant="h6" sx={{ color: colors.bluePrimary, fontWeight: 'bold', mb: 1 }}>
                      Consolidado por Dia
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                      Análise de pneus e outros produtos por dia
                    </Typography>
                  </Box>
                </Item>
              </Grid>

              {/* Card - Relatório por Mês */}
              <Grid item xs={12} sm={6} md={4} sx={{display: isAdm ? 'flex' : 'none'}}>
                <Item onClick={() => NavigateTo("../relatorio-pedidos-mes")}>
                  <Box sx={{
                    display: isAdm ? 'flex' : 'none',
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 1
                  }}>
                    <CalendarMonthIcon
                      sx={{
                        color: colors.accent,
                        fontSize: '2.5em',
                        mb: 1
                      }}
                    />
                    <Typography variant="h6" sx={{ color: colors.bluePrimary, fontWeight: 'bold', mb: 1 }}>
                      Consolidado por Mês
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                      Análise mensal de pedidos, itens e valores
                    </Typography>
                  </Box>
                </Item>
              </Grid>

              {/* Card - Relatório Detalhado de Pedidos */}
              <Grid item xs={12} sm={6} md={4}>
                <Item onClick={() => NavigateTo("../relatorio-pedidos-detalhado")}>
                  <Box sx={{
                    display:'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 1
                  }}>
                    <DescriptionIcon
                      sx={{
                        color: colors.accent,
                        fontSize: '2.5em',
                        mb: 1
                      }}
                    />
                    <Typography variant="h6" sx={{ color: colors.bluePrimary, fontWeight: 'bold', mb: 1 }}>
                      Pedidos por cliente
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                      Visualização detalhada de pedidos com clientes e produtos
                    </Typography>
                  </Box>
                </Item>
              </Grid>

              {/* Card - Consulta CNPJ (Placeholder para futuro) 
                  <Grid item xs={12} sm={6} md={4}>
                    <Item>
                      <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center',
                        p: 1,
                        opacity: 0.6
                      }}>
                        <Box sx={{ 
                          width: '4em', 
                          height: '4em', 
                          bgcolor: '#e0e0e0', 
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mb: 1
                        }}>
                          <Typography variant="h4" sx={{ color: '#999' }}>
                            🔍
                          </Typography>
                        </Box>
                        <Typography variant="h6" sx={{ color: '#999', fontWeight: 'bold', mb: 1 }}>
                          Consulta CNPJ
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#999', textAlign: 'center' }}>
                          Em desenvolvimento
                        </Typography>
                      </Box>
                    </Item>
                  </Grid>
                  */}
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  )
}